import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectAllDirective } from '../../directives/selectAll.directive';

import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { TailwindInputDirective2 } from '../input/tailwind-input2.directive';

@Component({
  selector: 'app-dropdown-minimal-menu',
  styles: [
    `
      @reference "tailwindcss";
      :host {
        @apply flex;
      }
    `,
  ],
  templateUrl: './dropdown-minimal-menu.component.html',
  imports: [CdkOverlayOrigin, CdkConnectedOverlay, SelectAllDirective, TailwindInputDirective2],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMinimalMenuComponent {
  @Input()
  dropdownHeader!: string;
  @Input()
  hasSearch = false;

  @Output()
  searchValueChanged = new EventEmitter<string>();

  isOpen = false;

  click(): void {
    this.isOpen = false;
  }

  searchValue(event: any) {
    if (event.target) {
      this.searchValueChanged.emit(event.target.value ?? '');
    }
  }

  menuOpen(event: Event) {
    this.isOpen = true;
    this.searchValueChanged.emit('');
    event.stopPropagation();
    event.preventDefault();
  }
}
